module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"footer":{"free_delivery":"Livraison gratuite","all_stores":"dans toutes les boutiques*","delivery_disclaimer":"hors offres partenaires"}},"es":{"footer":{"free_delivery":"Envíos gratuitos","all_stores":"en todas las tiendas"}},"it":{"footer":{"free_delivery":"Consegna gratuita","all_stores":"in tutti i negozi"}}}')
  delete Component.options._Ctor
}
